module.exports = __webpack_public_path__ + "static/media/unlock.ac1a5fab.svg";